import { render } from "./BaseTextElement.vue?vue&type=template&id=47a3d281&scoped=true&ts=true"
import script from "./BaseTextElement.vue?vue&type=script&lang=ts"
export * from "./BaseTextElement.vue?vue&type=script&lang=ts"

import "./BaseTextElement.vue?vue&type=style&index=0&id=47a3d281&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a3d281"]])

export default __exports__